import React from 'react';

// SmartIcon component for Material Design Icons (MDI)
// Usage: <SmartIcon name="file-tree-outline" size="24px" color="blue" />
export const SmartIcon = ({ name, size = "24px", color = "currentColor" }) => {
  const iconStyle = {
    fontSize: size,
    color: color,
    display: 'inline-block',
  };

  return (
    <span style={iconStyle} className={`mdi mdi-${name}`}></span>
  );
};

export default SmartIcon;

// Example usage:
// import SmartIcon from './SmartIcon';
//
// function MyComponent() {
//   return (
//     <div>
//       <SmartIcon name="file-tree-outline" size="36px" color="red" />
//       <SmartIcon name="account" size="24px" color="#333" />
//       <SmartIcon name="heart" size="48px" color="pink" />
//     </div>
//   );
// }

// NOTE: You must include the MDI font in your project:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">